import { useBadgeCount } from './useBadgeCount';
import { useFaviconBadge } from './useFaviconBadge';
import { useNotificationFeatures } from './useNotificationFeatures';
import { useUnreadCount } from './useUnreadCount';

export function useNotificationFavicon() {
  const { badgeEnabled, groupingEnabled } = useNotificationFeatures();

  const { data: badgeCount } = useBadgeCount({ enabled: badgeEnabled, grouped: groupingEnabled });
  const { data: unreadCount } = useUnreadCount({
    enabled: !badgeEnabled,
    grouped: groupingEnabled,
  });

  const count = badgeEnabled ? (badgeCount ?? 0) : (unreadCount ?? 0);
  useFaviconBadge(count > 0);
}
